<template>
    <div class="row">
        <div class="col-12 col-md-5 offset-md-1">
            <div class="form-group">
                <label for="member-id"> Member ID </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="member-id"
                    type="text"
                    placeholder="Enter Member ID"
                    v-model="payer.memberId"
                />
            </div>
            <div class="form-group">
                <label for="group-name"> Group Name </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="group-name"
                    type="text"
                    placeholder="Enter Group Name"
                    v-model="payer.groupName"
                />
            </div>
            <div class="form-group">
                <label for="group-id"> Group ID </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="group-id"
                    type="text"
                    placeholder="Enter Group ID"
                    v-model="payer.groupId"
                />
            </div>
            <div class="form-group">
                <label for="relationship-to-insured">
                    Relationship to Insured
                    <span class="text-danger">*</span>
                </label>
                <select
                    class="form-select"
                    name="relationship-to-insured"
                    v-model="payer.relationshipToInsured"
                    @blur="v$.payer.relationshipToInsured.$touch"
                    :class="`${!v$.payer.relationshipToInsured.$error ? '' : 'field-invalid'}`"
                >
                    <option :value="null">Select Relationship to Insured</option>
                    <option
                        v-for="[key, value] of enumToMap(relationshipToInsuredEnum)"
                        :key="key"
                        :value="value.value"
                    >
                        {{ value.name }}
                    </option>
                </select>
                <span v-if="v$.payer.relationshipToInsured.$error" class="field-invalid"
                    >Relationship is required.</span
                >
            </div>
            <div class="form-group">
                <label for="group-id"> Case Manager </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="group-id"
                    type="text"
                    placeholder="Enter Case Manager"
                    v-model="payer.caseManager"
                />
            </div>
            <div class="form-group">
                <label for="employer-name"> Employer Name </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="employer-name"
                    type="text"
                    placeholder="Enter Employer Name"
                    v-model="payer.employerName"
                />
            </div>
        </div>
        <div class="col-12 col-md-5">
            <div
                class="form-group"
                v-if="payer.type === roomAndBoardTypeValue || payer.type === palliativeCareTypeValue"
            >
                <label for="bill-as"> Bill As </label>
                <select class="form-select" name="bill-as" v-model="payer.billAsType">
                    <option v-for="[key, value] of enumToMap(payerSequenceCodeEnum)" :key="key" :value="value.value">
                        {{ value.name }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label for="deductible-amount"> Deductible Amount </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="deductible-amount"
                    type="text"
                    placeholder="Enter Deductible Amount"
                    v-model="payer.deductibleAmount"
                    v-number-only
                />
            </div>
            <div class="form-group d-flex flex-row justify-content-between mb-1">
                <div class="w-40" role="group" aria-label="Basic radio toggle button group">
                    <label for="has-deductible-met" class="me-2"> Deductible Met </label>
                    <div>
                        <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
                            <label
                                :class="`btn btn-outline-secondary ${payer.deductibleMet ? 'active' : ''}`"
                                @click="hasDeductibleMetChanged(true)"
                            >
                                <input type="radio" class="btn-check" name="has-deductible-met" autocomplete="off" />
                                Yes
                            </label>
                            <label
                                :class="`btn btn-outline-secondary ${payer.deductibleMet ? '' : 'active'}`"
                                @click="hasDeductibleMetChanged(false)"
                            >
                                <input type="radio" class="btn-check" name="has-deductible-met" autocomplete="off" />
                                No
                            </label>
                        </div>
                    </div>
                </div>
                <div v-if="isApplicationPalliative" class="w-60">
                    <label for="prior-authorization"> Prior Authorization Required </label>
                    <div>
                        <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
                            <label
                                :class="`btn btn-outline-secondary ${payer.requirePriorAuthorization ? 'active' : ''}`"
                                @click="requireAuthorizationChanged(true)"
                            >
                                <input type="radio" hidden name="require-authorization" autocomplete="off" /> Yes
                            </label>
                            <label
                                :class="`btn btn-outline-secondary ${payer.requirePriorAuthorization ? '' : 'active'}`"
                                @click="requireAuthorizationChanged(false)"
                            >
                                <input type="radio" hidden name="require-authorization" autocomplete="off" /> No
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="copay-amount"> Copay Amount </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="copay-amount"
                    type="text"
                    placeholder="Enter Copay Amount"
                    v-model="payer.copayAmount"
                />
            </div>
            <template v-if="isApplicationPalliative">
                <div class="form-group">
                    <label for="coinsurance-amount"> Coinsurance Amount </label>
                    <input
                        class="form-control"
                        maxlength="50"
                        name="coinsurance-amount"
                        type="text"
                        placeholder="Enter Coinsurance Amount"
                        v-model="payer.coinsuranceAmount"
                    />
                </div>
                <div class="form-group">
                    <label for="out-of-pocket-amount"> Out-of-Pocket Maximum Amount </label>
                    <input
                        class="form-control"
                        maxlength="50"
                        name="out-of-pocket-amount"
                        type="text"
                        placeholder="Enter Out-of-Pocket Maximum Amount"
                        v-model="payer.outOfPocketMaxAmount"
                    />
                </div>
                <div class="form-group">
                    <label for="out-of-pocket-met"> Out-of-Pocket Maximum Met </label>
                    <div>
                        <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
                            <label
                                :class="`btn btn-outline-secondary ${payer.isOutOfPocketMaxMet ? 'active' : ''}`"
                                @click="outOfPocketMaxMetChanged(true)"
                            >
                                <input type="radio" hidden name="out-of-pocket-met" autocomplete="off" /> Yes
                            </label>
                            <label
                                :class="`btn btn-outline-secondary ${payer.isOutOfPocketMaxMet ? '' : 'active'}`"
                                @click="outOfPocketMaxMetChanged(false)"
                            >
                                <input type="radio" hidden name="out-of-pocket-met" autocomplete="off" /> No
                            </label>
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="showSubscriberName">
                <div class="form-group">
                    <label for="subs-first-name"> Subscriber First Name <span class="text-danger">*</span> </label>
                    <input
                        class="form-control"
                        name="subs-first-name"
                        type="text"
                        placeholder="Enter Subscriber First Name"
                        v-model="payer.subscriberFirstName"
                        @blur="v$.payer.subscriberFirstName.$touch"
                        :class="`${!v$.payer.subscriberFirstName.$error ? '' : 'field-invalid'}`"
                    />
                    <span v-if="v$.payer.subscriberFirstName.$error" class="field-invalid"
                        >Subscriber First Name is required.</span
                    >
                </div>
                <div class="form-group">
                    <label for="subs-last-name"> Subscriber Last Name <span class="text-danger">*</span> </label>
                    <input
                        class="form-control"
                        name="subs-last-name"
                        type="text"
                        placeholder="Enter Subscriber Last Name"
                        v-model="payer.subscriberLastName"
                        @blur="v$.payer.subscriberLastName.$touch"
                        :class="`${!v$.payer.subscriberLastName.$error ? '' : 'field-invalid'}`"
                    />
                    <span v-if="v$.payer.subscriberLastName.$error" class="field-invalid"
                        >Subscriber Last Name is required.</span
                    >
                </div>
            </template>
            <div class="form-group" v-if="!isApplicationPalliative">
                <label for="copay-amount"> Comments </label>
                <textarea
                    class="form-control"
                    id="comments"
                    v-model="payer.comments"
                    rows="4"
                    maxlength="300"
                ></textarea>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { enumToMap } from "../../../../../../common/vue-helpers/modifiers/enum-modifiers";
import { useVuelidate } from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";
import { PatientPayor } from "../../../../../../resources-vue/vue-models/patient-payor";

export default defineComponent({
    props: {
        payer: {
            type: PatientPayor
        },
        relationshipToInsuredEnum: {
            default: null
        },
        payerSequenceCodeEnum: {
            default: null
        },
        hasDeductibleMetChanged: {
            type: Function
        },
        isApplicationPalliative: {
            type: Boolean
        },
        showSubscriberName: {
            type: Boolean
        },
        roomAndBoardTypeValue: {
            type: Number
        },
        palliativeCareTypeValue: {
            type: Number
        },
        requireAuthorizationChanged: {
            type: Function
        },
        outOfPocketMaxMetChanged: {
            type: Function
        }
    },
    data() {
        return {
            enumToMap,
            v$: useVuelidate()
        };
    },

    validations() {
        return {
            payer: {
                relationshipToInsured: { required },
                subscriberFirstName: {
                    required: requiredIf(() => {
                        return this.showSubscriberName;
                    })
                },
                subscriberLastName: {
                    required: requiredIf(() => {
                        return this.showSubscriberName;
                    })
                }
            }
        };
    }
});
</script>
